import { takeLatest } from 'redux-saga/effects';
import { GET_BROWSER_LOCATION_START } from 'redux/actions/types';
import { browserLocationSaga } from './browser-location-saga';

export default function* browserLocationSagas() {
  yield takeLatest(GET_BROWSER_LOCATION_START, browserLocationSaga);
}
